// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"96":"5cda21fe894c3eab","843":"3c65afbbd7433913"}[chunkId] + ".js";
};